import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

const Container = styled.div`
  width: 3em;
  height: 3em;
  position: relative;
  background-color: ${({ theme }) => theme.colors.firefly};
  border-radius: 50%;

  svg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    padding: 27.5%;
    color: ${({ theme }) => theme.colors.white};

    /* path {
      fill: ${({ theme, $bgColor }) =>
      theme.colors[$bgColor] || `currentColor`};
    } */

    /* ${({ $outline }) =>
      $outline &&
      css`
        fill: none;
        stroke: currentColor;
        stroke-width: 5px;
        filter: none;

        path {
          transform: scale(0.99);
          transform-origin: center center;
        }
      `} */
  }
`

const HexagonIcon = ({ iconSvg, outline, bgColor, ...props }) => {
  if (!iconSvg) return null

  return (
    <Container $outline={outline} $bgColor={bgColor} {...props}>
      {iconSvg}
    </Container>
  )
}

HexagonIcon.propTypes = {
  iconSvg: PropTypes.node,
}

export default HexagonIcon
